module.exports = __webpack_public_path__ + "static/img/PA.6c9c9f47.jpg";